export const ReplacementType = {
    SimpleTemplate: 'SimpleTemplate',
    SlottedTemplate: 'SlottedTemplate'
} as const;

export type ReplacementType = typeof ReplacementType[keyof typeof ReplacementType];
